import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBanner } from '@mylighthouse/prism-ember';
import { not } from 'ember-truth-helpers';

interface MarketSettingsCentralMappingBannerSavingSignature {
  Args: {
    isMappingTaskRunning: boolean;
    refreshMappingEntries: () => void;
  };
}

export default class MarketSettingsCentralMappingBannerSaving extends Component<MarketSettingsCentralMappingBannerSavingSignature> {
  @service('central-mapping/saving')
  declare centralMappingSaving: Services['central-mapping/saving'];

  @service declare intl: Services['intl'];

  get bannerSavingPrimaryAction(): {
    action: () => void;
    disabled: boolean;
    isLoading: boolean;
    label: string;
  } {
    const { refreshMappingEntries, isMappingTaskRunning } = this.args;

    return {
      label: this.intl.t('central_mapping.saving.refresh_page'),
      disabled: isMappingTaskRunning,
      isLoading: isMappingTaskRunning,
      action: (): void => refreshMappingEntries(),
    };
  }

  get bannerSavingText(): string {
    const { savingStatus } = this.centralMappingSaving;

    if (!savingStatus) {
      return this.intl.t('central_mapping.saving.status_not_available');
    }

    const { subscriptionsProcessed, totalSubscriptionsProcessing } =
      savingStatus;

    return this.intl.t('central_mapping.saving_rate_codes', {
      numberCurrentProgress: subscriptionsProcessed,
      numberTotal: totalSubscriptionsProcessing,
    });
  }

  <template>
    <PrismBanner
      @bannerMessage={{this.bannerSavingText}}
      @bannerStyle="info"
      @hasCta={{not this.centralMappingSaving.savingStatus}}
      @icon="automation"
      @isLoading={{true}}
      @isOneLine={{true}}
      @position="island"
      @primaryAction={{this.bannerSavingPrimaryAction}}
      data-test-id="mapping-saving-banner"
    />
  </template>
}
